<template>
    <div v-if="status" class="swal2-container swal2-fade swal2-shown" style="overflow-y: auto;; ">
        <div
            aria-labelledby="swal2-title" aria-describedby="swal2-content" class="swal2-popup swal2-modal swal2-show"
            tabindex="-1" role="dialog" aria-live="assertive" aria-modal="true" style="display: flex;">
            <div class="swal2-header">
              <button type="button" class="swal2-close" @click="status=false">×</button>
            </div>
            <p style="margin: 5px; text-align: center">Мы отправляем выплаты на банковские карты выпущенные в рф. Для получения средств на qiwi, yoomoney или другие способы » свяжитесь с техподдержкой</p>

            <div>
                <div class="block url-input">
                  <div class="inner" style="transition: background 1s;">
                    <div class="label-icon">
                      <icon name="credit-card" scale="1.8"/>
                    </div>
                    <input v-model="phone" :placeholder="$t('messages.partners.phone')" type="text"/>
                  </div>
                </div>
            </div>

            <p style="margin: 5px; text-align: center">У вас должно быть подключено СБП. <br/><a target="_blank" href="https://help.tinkoff.ru/black/debit-common/sbp-turn-on">Как это сделать?</a></p>

            <div class="swal2-actions" style="display: flex;">
                <button style="background: #34A853" type="button" @click="payment" class="swal2-confirm swal2-styled">{{ $t('messages.partners.order') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import ClickOutside from 'vue-click-outside'

    export default {
        name: 'PayoutModal',
        directives: {
          ClickOutside
        },
        data: function () {
            return {
                status: false,
                phone: '',
            }
        },
        methods: {
          payment: function () {
            this.$http.jsonp('partners', {
              params: {
                key: this.$parent.key,
                phone: this.phone,
                lang: this.$parent.lang,
              }
            }).then(function(response){
              if(response.body.status)
              {
                this.$swal({
                  title: this.$t('messages.partners.ordersuccess'),
                  text: '',
                  icon: 'success',
                });

              }
              else
              {
                this.$swal({
                  title: this.$t('messages.alerts.error'),
                  text: response.body.message,
                  icon: 'error',
                });
              }
            }, function () {

            });
          },
          open: function(){
            this.status = true
          },
          close: function(){
            this.status = false
          },
        }
    }
</script>

<style scoped>

    .block {
      margin-top: 10px;
    }

    .url-input .inner {
        background: #D9E2FA;
        padding: 1px;
    }

    .block .label-icon, .block .label-plus, .block .label-minus {
        line-height: 52px;
        width: 52px;
        height: 52px;
    }

    .block .label-plus, .block .label-icon + input, .block .label-minus + input {
      margin-left: -52px;
    }

    .swal2-actions {
      margin: 0;
    }

</style>